import { all, call, put, takeLatest } from "redux-saga/effects";
import { FILTER_BAR } from "./actionTypes";
import { BUSINESS_URL, DOCUMENT_CENTER_URL, PRODUCT_URL, REGIONS_URL, SECTION_URL, SNIPPETS_URL, USER_URL } from "../../helpers/url_api_helper";
import { getFilterData } from "./actions";
import { normalizeApiError } from "../../helpers/utils/normalizeApiError";


function* getFilterDataSaga({ payload }) {
  const { page } = payload;
  
  try {
    const callsByPage = {
      documents: {
        regions: call(REGIONS_URL.getRegionAll),
        business: call(BUSINESS_URL.getBusinessAll),
        users: call(USER_URL.getUserDropDown),
        products: call(PRODUCT_URL.getProductsList),
        sections: call(SECTION_URL.getSectionAll),
        snippets: call(SNIPPETS_URL.getSnippetAll),
      },

      sections: {
        regions: call(REGIONS_URL.getRegionAll),
        business: call(BUSINESS_URL.getBusinessAll),
        users: call(USER_URL.getUserDropDown),
        products: call(PRODUCT_URL.getProductsList),
        snippets: call(SNIPPETS_URL.getSnippetAll),
      },

      snippets: {
        users: call(USER_URL.getUserDropDown),
        products: call(PRODUCT_URL.getProductsList),
        sections: call(SECTION_URL.getSectionAll),
      },

      documentsCenter: {
        regions: call(DOCUMENT_CENTER_URL.getDocumentCenterRegions),
        business: call(DOCUMENT_CENTER_URL.getDocumentCenterBusiness),
        products: call(DOCUMENT_CENTER_URL.getDocumentCenterProducts),
      },

      bulk: {
        regions: call(REGIONS_URL.getRegionAll),
        business: call(BUSINESS_URL.getBusinessAll),
        users: call(USER_URL.getUserDropDown),
        products: call(PRODUCT_URL.getProductsList),
        sections: call(SECTION_URL.getSectionAll),
        snippets: call(SNIPPETS_URL.getSnippetAll),
      },
    };

    const calls = callsByPage[page] || {};

    const {
      regions,
      business,
      users,
      sections,
      snippets,
      products,
    } = yield all(calls);

    yield put(
      getFilterData.success({
        ...(regions && {
          regions: regions.map(r => ({ value: r.id, label: r.name })),
        }),
        ...(business && {
          business: business.map(b => ({ value: b.id, label: b.name })),
        }),
        ...(users && {
          users: users.map(u => ({ value: u.email, label: u.login })),
        }),
        ...(sections && {
          sections: sections.map(s => ({ value: s.id, label: s.title })),
        }),
        ...(snippets && {
          snippets: snippets.map(s => ({ value: s.id, label: s.title })),
        }),
        ...(products && {
          products: products.map(p => ({ value: p, label: p })),
        }),
      })
    );
  } catch (error) {
    yield put(
      getFilterData.fail(
        normalizeApiError(
          error,
          "Something went wrong retrieving the system's data"
        )
      )
    );
  }
}


export default function* filterBarSagas() {
    yield takeLatest(FILTER_BAR.GET_FILTER_DATA.REQUEST, getFilterDataSaga);
}